import { SBCAAS_CLASSIC_LABEL, SBCAAS_MODERN_LABEL } from '@/constants/sbcaas';
import { SRT_TRUNK_TYPE_ID } from '@/constants/srt';

/**
 * Classic SBCaaS trunk type's backend-owned name.
 *
 * Trunk types carry no service-type field, and the classic type is not seeded
 * with a fixed id, so the name is the only thing available to match it on.
 */
export const SIP_TRUNK_TYPE_NAME = 'SIP Trunk';

/**
 * Customer-facing name for a trunk type.
 *
 * Both SBCaaS variants are named after their internals in the database — "SRT"
 * for the modern service, "SIP Trunk" for the classic one — neither of which
 * means anything to a customer. Only the label is swapped: routing, filtering
 * on the raw type and saved values all keep the backend's own name.
 */
export const trunkTypeDisplayName = (trunkType) => {
    if (trunkType?.id === SRT_TRUNK_TYPE_ID) {
        return SBCAAS_MODERN_LABEL;
    }
    if (trunkType?.name === SIP_TRUNK_TYPE_NAME) {
        return SBCAAS_CLASSIC_LABEL;
    }
    return trunkType?.name ?? '';
};
